import log from "loglevel";
import type { RouteRecordRaw } from "vue-router";
import { createRouter, createWebHistory } from "vue-router";

import Start from "./views/Start";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/authorize",
    name: "Start",
    component: Start,
  },
  {
    path: "/verify",
    name: "Verify",
    component: () => import("@/views/Verify"),
  },
  {
    path: "/passkey",
    name: "Passkey",
    component: () => import("@/views/Passkeys"),
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

router.beforeEach((guard) => {
  log.info(guard);
});

export default router;
